import { useMemo } from 'react'
import { useBannerCallout } from './banner-callout-context'

export const useBannerActions = () => {
  const { setBannerCallout } = useBannerCallout()

  return useMemo(
    () => ({
      setBanner: setBannerCallout
    }),
    [setBannerCallout]
  )
}
